// Custom components
import React from "react";

function InputField(props) {
  const { label, id, extra, type, placeholder, variant, state, disabled,
    value, defaultValue, onChange, inputMode, autoComplete, maxLength, min, max, step } = props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm font-medium text-foreground ${variant === "auth" ? "" : "ml-0.5"}`}
      >
        {label}
      </label>
      <input
        disabled={disabled}
        type={type}
        id={id}
        placeholder={placeholder}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        inputMode={inputMode}
        autoComplete={autoComplete}
        maxLength={maxLength}
        min={min}
        max={max}
        step={step}
        className={`mt-2 flex h-10 w-full items-center justify-center rounded-sm border bg-background px-3 text-sm text-foreground outline-none transition-[color,box-shadow] placeholder:text-muted-foreground focus:border-ring focus:ring-[3px] focus:ring-ring/50 ${
          disabled === true
            ? "cursor-not-allowed border-border !bg-muted opacity-60"
            : state === "error"
            ? "border-no text-no placeholder:text-no/70"
            : state === "success"
            ? "border-yes text-yes placeholder:text-yes/70"
            : "border-border"
        }`}
      />
    </div>
  );
}

export default InputField;
